<template>
  <div class="page-content partners">
    <all-partner-callers />
    <div class="row">
      <div class="col-md-6 col-sm-12 col-xs-12">
        <partnership-account />
        <update-partner-tip />
        <update-partner-subsidy-pot />
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12">
        <assign-partner-to-ride />
        <update-partner-caller-rides />
        <update-partner-caller-ride-allowance-tier />
        <add-partner-caller-credits />
        <remove-partner-caller-credits />
        <reactivate-partner-member />
        <update-local-taxi-partner-ride />
      </div>
    </div>
    <partners-table />
    <partner-members v-if="!!partnerToViewMembers" />
    <rides-taken-per-partner />
    <subsidy-location-list />
    <partner-geo-validation />
    <partner-new-subsidy-migration v-if="isAdmin" />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent, toRefs } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { usePartner } from '@/use/partner';
import { useProfile } from '@/use/profile';

const AllPartnerCallers = defineAsyncComponent(() => import('./Partners/AllPartnerCallers.vue') as any);
const PartnersTable = defineAsyncComponent(() => import('./Partners/PartnersTable.vue') as any);
const PartnershipAccount = defineAsyncComponent(() => import('./Partners/PartnershipAccount.vue') as any);
const PartnerMembers = defineAsyncComponent(() => import('./Partners/PartnerMembers.vue') as any);
const UpdatePartnerCallerRides = defineAsyncComponent(() => import('./Partners/UpdatePartnerCallerRides.vue') as any);
const UpdatePartnerCallerRideAllowanceTier = defineAsyncComponent(
  () => import('./Partners/UpdatePartnerCallerRideAllowanceTier.vue') as any,
);
const AddPartnerCallerCredits = defineAsyncComponent(() => import('./Partners/AddPartnerCallerCredits.vue') as any);
const RemovePartnerCallerCredits = defineAsyncComponent(() => import('./Partners/RemovePartnerCallerCredits.vue') as any);
const UpdateLocalTaxiPartnerRide = defineAsyncComponent(() => import('./Partners/UpdateLocalTaxiPartnerRide.vue') as any);
const AssignPartnerToRide = defineAsyncComponent(() => import('./Partners/AssignPartnerToRide.vue') as any);
const SubsidyLocationList = defineAsyncComponent(() => import('./Partners/SubsidyLocations/SubsidyLocationList.vue') as any);
const PartnerNewSubsidyMigration = defineAsyncComponent(
  () => import('./Partners/NewSubsidyMigration/PartnerNewSubsidyMigration.vue') as any,
);
const UpdatePartnerTip = defineAsyncComponent(() => import('./Partners/UpdatePartnerTip.vue') as any);
const UpdatePartnerSubsidyPot = defineAsyncComponent(() => import('./Partners/UpdatePartnerSubsidyPot.vue') as any);
const RidesTakenPerPartner = defineAsyncComponent(() => import('./Partners/RidesTakenPerPartner.vue') as any);
const PartnerGeoValidation = defineAsyncComponent(() => import('../Shared/PartnerGeoValidation.vue') as any);
const ReactivatePartnerMember = defineAsyncComponent(() => import('./Partners/ReactivatePartnerMember.vue') as any);

const { partnerToViewMembers } = usePartner();
const { userRoles } = useProfile();
const { isAdmin } = toRefs(userRoles);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
